import { useState, useEffect } from 'react';
import {ApiUrl} from "../../ApiUrl"

const useFetchRoutes = (isTransportAvailed) => {
    const [routes, setRoutes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRoutes = async () => {
            if (isTransportAvailed) {
                try {
                    // Get orgId and branchId from localStorage
                    const orgId = localStorage.getItem('orgId');
                    const branchId = localStorage.getItem('branchId');

                    if (!orgId || !branchId) {
                        throw new Error('Organization ID or Branch ID not found in local storage');
                    }

                   
                    const url = `${ApiUrl.apiurl}Transport/GetAllRouteBasedOnOrgnizationBranch/${orgId}/${branchId}`;

                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error('Failed to fetch routes');
                    }

                    const data = await response.json();

                    setRoutes(Array.isArray(data?.data) ? data.data : []);
                } catch (err) {
                    setError(err.message);
                    setRoutes([]);
                } finally {
                    setLoading(false);
                }
            } else {
                setRoutes([]);
                setLoading(false);
            }
        };

        fetchRoutes();
    }, [isTransportAvailed]);

    return { routes, loading, error };
};

export default useFetchRoutes;
